/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedProductAdWrapper_user = {
    readonly tradeFirm?: {
        readonly serviceId: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"TradeRewardsMessagingWrapper_user">;
    readonly " $refType": "SbSharedProductAdWrapper_user";
};
export type SbSharedProductAdWrapper_user$data = SbSharedProductAdWrapper_user;
export type SbSharedProductAdWrapper_user$key = {
    readonly " $data"?: SbSharedProductAdWrapper_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedProductAdWrapper_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedProductAdWrapper_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeFirm",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeRewardsMessagingWrapper_user",
      "args": null
    }
  ]
};
(node as any).hash = 'f2a595d19e2f86548e5bbb93343c1110';
export default node;
